import {setCustomerOfferChapterCommercialOptions} from "@project/sdk/sales";
import {SetCustomerOfferChapterCommercialOptionsResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../../../customerOffer-keys";
import {setCustomerOfferChapterCommercialOptionsFormSchema} from "./set-customer-offer-chapter-commercial-options.schema";
import type {SetCustomerOfferChapterCommercialOptionsFormPayload} from "./set-customer-offer-chapter-commercial-options.schema";

export function setCustomerOfferChapterCommercialOptionsMutationOptions(
  id: string,
  chapterId: string,
) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.setCustomerOfferChapterCommercialOptions,
    retry: false,
    mutationFn: async (payload: SetCustomerOfferChapterCommercialOptionsFormPayload) =>
      SetCustomerOfferChapterCommercialOptionsResponse.parse(
        await setCustomerOfferChapterCommercialOptions(
          id,
          chapterId,
          setCustomerOfferChapterCommercialOptionsFormSchema.parse(payload),
        ),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
